import { render, staticRenderFns } from "./RecurringOrderSettingForm.vue?vue&type=template&id=2bd45d2c&scoped=true&"
import script from "./RecurringOrderSettingForm.vue?vue&type=script&lang=ts&"
export * from "./RecurringOrderSettingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd45d2c",
  null
  
)

export default component.exports